const DEFAULT_EMAIL_EXTENSION = '@gmail.com';

export default { DEFAULT_EMAIL_EXTENSION };
